import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { TranslocoDirective } from "@jsverse/transloco";
import {
    NgbActiveModal,
    NgbModule,
    NgbNav,
    NgbNavContent,
    NgbNavItem,
    NgbNavItemRole,
    NgbNavLink,
    NgbNavLinkBase,
    NgbNavOutlet,
    NgbTooltip
} from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import {
    AddPlaybookFacade,
    IAddEditPlaybookFacade,
    IAddEditPlaybookFacadeToken
} from "../../../playbooks/add-edit-playbook/add-edit-playbook.facade";
import { PlaybooksListeningFacadeService } from "../../../store/playbooks-listening.facade.service";
import { LegalHubGuidelinesTabComponent } from "../legal-hub-guidelines-tab/legal-hub-guidelines-tab.component";
import { LegalHubSettingsTabComponent } from "../legal-hub-settings-tab/legal-hub-settings-tab.component";
 
import { NgClass } from '@angular/common';
import { CoreSidebarModule } from '@core/components';
import { CoreDirectivesModule } from '@core/directives/directives';
import { Actions, ofType } from '@ngrx/effects';
import { SharedModule } from 'app/main/shared/shared/shared.module';
import { takeUntil } from 'rxjs';
import * as PlaybookActions from '../../../store/playbooks.actions';
import { LHSubmitFormButtonTranslationKey } from '../legal-hub-side-bar';
import { LegalHubSideBarBaseComponent } from '../legal-hub-side-bar.base.component';

@Component({
  selector: 'app-add-playbook-side-bar',
  standalone: true,
    imports: [
        SharedModule,
        TranslocoDirective,
        NgbTooltip,
        CoreSidebarModule,
        CoreDirectivesModule,
        NgbNav,
        NgClass,
        NgbNavContent,
        NgbNavItem,
        NgbNavItemRole,
        NgbNavLink,
        NgbNavLinkBase,
        ReactiveFormsModule,
        LegalHubSettingsTabComponent,
        NgbNavOutlet,
        FormsModule,
        NgSelectModule,
        NgbModule,
        LegalHubGuidelinesTabComponent
    ],
  templateUrl: './add-playbook-side-bar.component.html',
  styleUrl: './add-playbook-side-bar.component.scss',
    providers:[
        {
            provide: IAddEditPlaybookFacadeToken,
            useExisting: AddPlaybookFacade
        },
        {
            provide: LHSubmitFormButtonTranslationKey,
            useValue: 'Save button text (save button) - save'
        }
    ],
})
export class AddPlaybookSideBarComponent extends LegalHubSideBarBaseComponent implements OnInit, OnDestroy{

    public playbookForm: UntypedFormGroup;

    constructor(
        private _formBuilder: UntypedFormBuilder,
        private _actions: Actions,
        _activeModal: NgbActiveModal,
        _playbooksListeningFacadeService:PlaybooksListeningFacadeService,
        @Inject(IAddEditPlaybookFacadeToken) _addEditPlaybookFacadeService:IAddEditPlaybookFacade) {
            super(_activeModal, _playbooksListeningFacadeService, _addEditPlaybookFacadeService);
    }

    ngOnInit(): void {
        super.ngOnInit();   
        this.playbookForm = this._formBuilder.group({
            name: ['', Validators.required],
            category: ['', Validators.required],
            purpose: [''],
            usage: [''],
            status:[0, Validators.required], // 0 for draft, 1 for published
            color: [this.DEFAULT_COLOR, Validators.required],
            guidelines: this._formBuilder.array([])
        });
        
        this._playbooksListeningFacadeService.fetchCategories();

        this._actions.pipe(
            ofType(PlaybookActions.addNewPlaybookSucceeded),
            takeUntil(this.onDestroy$)
        ).subscribe(() => {
            this._activeModal.close({refresh_listing: true});
        }); 

    }

    
    ngOnDestroy(): void {
        super.ngOnDestroy();
    }
}

